import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { FeatureFlagService, PRICING_ENABLED_FLAG_KEY } from './feature-flag.service';

/**
 * Gates `/pricing` behind the `pricing-enabled` Amplitude flag, falling back
 * to the `pricing` environment flag when Amplitude has no variant for the
 * caller (or Amplitude is disabled for the env). This mirrors the sibling
 * guards (`scorecardEnabledGuard`, `agentsNavEnabledGuard`) so QA can roll
 * out `/pricing` per-tenant/per-user via Amplitude without a redeploy.
 *
 * The `pricing` env flag is `false` in dev/test/prod, so every deployed
 * environment is off by default until Amplitude reports `'on'` for the caller;
 * only local dev (where Amplitude is disabled) leaves it open. This is the
 * route-level mirror of the nav gate in `app-layout.ts`. Note `pricing` is the
 * visibility gate — distinct from `pricingApi`, which only switches the page
 * between the live `/pricing/*` API and `MOCK_PRICING`.
 */
export const pricingEnabledGuard: CanActivateFn = async () => {
  const flags = inject(FeatureFlagService);
  const router = inject(Router);
  await flags.ready();
  return (
    flags.isEnabledWithFallback(PRICING_ENABLED_FLAG_KEY, environment.features.pricing) ||
    router.createUrlTree(['/home'])
  );
};
